var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-view"},[_c('div',{staticClass:"auth-bg"},[_c('div',{staticClass:"auth-bg__base"}),_c('div',{staticClass:"auth-bg__glows"}),_c('div',{staticClass:"auth-bg__panels"}),_c('div',{staticClass:"auth-bg__dots"})])])
}]

export { render, staticRenderFns }